//====================================//
//    SHUFFLED INK | GRAVITY FORMS    //
//====================================//

(function($) {
	$(document).ready(function() {

		// Add data-position="first" to the first .gsection since CSS can't do it
		$( '.gsection' ).first().attr( 'data-position', 'first' );


		// on product field change, check if board game components needs to be shown
		$( '.gfield.product select' ).on( 'change', function() {
			
			if ( $(this).val() == 'board-games' ) {
				$( '.board-game-components' ).css( 'display', 'inline-block' );
			} else {
				$( '.board-game-components').css( 'display', 'none' );
			}
		});

	}); // document.ready
})(jQuery);
